import { useState, useRef, useMemo } from 'react';
import { change } from 'redux-form';
import OutsideClickHandler from 'react-outside-click-handler';

import { InputBox, NodeBox, RacksBox, StyledCheckbox, StyledPopup, Content, InputContent } from './RackSelect.styled';

export const RackSelect = (props) => {
  const { placeholder, label, className, disabled, data, input, meta } = props;
  const { name, value } = input;
  const { dispatch, form } = meta;

  const [open, setOpen] = useState(false);
  const wrapper = useRef(null);
  const popup = useRef(null);

  const showPopup = () => {
    if (disabled) {
      return;
    }

    setOpen((val) => !val);
  };

  const setValue = (e, fieldValue, type) => {
    let newValue = [...value];

    if (e.target.checked) {
      if (type === 'rack') {
        newValue.push(fieldValue);
      } else if (type === 'node') {
        data[fieldValue].racks.forEach((rack) => {
          if (!newValue.includes(rack)) {
            newValue.push(rack);
          }
        });
      }
    } else {
      if (type === 'rack') {
        newValue.splice(newValue.indexOf(fieldValue), 1);
      } else if (type === 'node') {
        data[fieldValue].racks.forEach((rack) => {
          if (newValue.includes(rack)) {
            newValue.splice(newValue.indexOf(rack), 1);
          }
        });
      }
    }

    if (newValue.length === 0) {
      newValue = '';
    }
    dispatch(change(form, name, newValue));
  };

  const getInputs = () => {
    let nodes = [];

    const keys = Object.keys(data);
    keys.sort((a, b) => {
      if (a > b) {
        return 1;
      }
      if (a < b) {
        return -1;
      }
      return 0;
    });

    keys.forEach((node) => {
      const item = data[node];
      const id = item.id;
      const racks = item.racks.map((rack) => {
        return (
          <StyledCheckbox key={rack} className="checkbox">
            <label>
              <input onChange={(e) => setValue(e, rack, 'rack')} type="checkbox" name={rack} checked={Array.isArray(value) ? value.includes(rack) : false} />
              <span>С{rack}</span>
            </label>
          </StyledCheckbox>
        );
      });
      nodes.push(
        <RacksBox key={`node-${id}`}>
          <StyledCheckbox bold key={id} className="checkbox">
            <label>
              <input onChange={(e) => setValue(e, node, 'node')} type="checkbox" name={id} checked={nodeIsChecked(value, node)} />
              <span>У{id}</span>
            </label>
          </StyledCheckbox>
          {racks}
        </RacksBox>
      );
    });

    return (
      <NodeBox>
        <StyledCheckbox key={'all'} className="checkbox" bold>
          <label>
            <input onChange={selectAll} checked={isCheckedAll()} type="checkbox" name="all" />
            <span>Все стойки</span>
          </label>
        </StyledCheckbox>
        {nodes}
      </NodeBox>
    );
  };

  const nodeIsChecked = (values, node) => {
    return data[node].racks.every((rack) => {
      return values.includes(rack);
    });
  };

  const getDisplayedValue = () => {
    if (Array.isArray(value) && value.length > 0) {
      let displayedValue = [];
      let subsidiaryValues = [];

      Object.values(data).forEach((node) => {
        subsidiaryValues = [];
        for (let i = 0; i < node.racks.length; i++) {
          for (let j = 0; j < value.length; j++) {
            if (node.racks[i] === value[j]) {
              subsidiaryValues.push(value[j]);
            }
          }
          if (subsidiaryValues.length === node.racks.length) {
            displayedValue.push(getDecorateName('node', node.id));
            subsidiaryValues = [];
          }
        }
        subsidiaryValues.forEach((value) => {
          displayedValue.push(getDecorateName('rack', value));
        });
      });
      return displayedValue.join(', ');
    }
    return '';
  };

  const getDecorateName = (type, id) => {
    const prefix = type === 'node' ? 'У' : 'C';
    return `${prefix}${id}`;
  };

  const isCheckedAll = () => {
    let allRacks = getAllRacksCount();
    return allRacks.length === value.length;
  };

  const selectAll = () => {
    let newValue = '';
    let allRacks = getAllRacksCount();

    if (value.length !== allRacks.length) {
      newValue = allRacks;
    }

    dispatch(change(form, name, newValue));
  };

  const getAllRacksCount = () => {
    let allRacks = [];

    Object.values(data).forEach((node) => {
      allRacks = allRacks.concat(node.racks);
    });

    return allRacks;
  };

  const inputs = useMemo(() => getInputs(), [data]);

  return (
    <Content className={className} ref={wrapper}>
      <label>{label}</label>
      <InputContent ref={popup}>
        <InputBox onClick={showPopup} $popupIsOpen={open}>
          <input placeholder={placeholder} value={getDisplayedValue()} disabled />
        </InputBox>
        <OutsideClickHandler
          onOutsideClick={(event) => {
            if (wrapper && !wrapper.current.contains(event.target)) {
              if (open) {
                showPopup();
              }
            }
          }}
        >
          <StyledPopup className="popup" $popupIsOpen={open}>
            {inputs}
          </StyledPopup>
        </OutsideClickHandler>
      </InputContent>
    </Content>
  );
};
